
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/electric-cars",
      function () {
        return require("private-next-pages/electric-cars/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/electric-cars"])
      });
    }
  